/* Lezioni (port di lessons.js) — lezioni, classi consigliate, corsi. */
import { useEffect, useState } from "react";
import { ptapp } from "@/lib/ptapp";
import { Card, AccountSelect, Pill, COORD, asList } from "./_ui";

const fmtMoney = (p: any) => { if (p == null) return ""; if (typeof p === "object") { const a = p.amount ?? p.value ?? p.total ?? p.price; const c = p.currency || p.currency_id || ""; return a == null ? "" : String(a) + (c ? " " + c : ""); } return String(p); };
const pickPrice = (o: any) => fmtMoney(o.price ?? o.amount ?? o.fee ?? o.total_price ?? o.price_per_person ?? o.registration_info?.price ?? o.pricing?.price ?? o.cost);
const pickDate = (o: any) => { const s = o.start_date ?? o.start ?? o.start_at ?? o.starts_at ?? o.date ?? o.from ?? o.start_time ?? (o.slot && (o.slot.start || o.slot.start_date)); if (!s) return ""; const d = new Date(s); return isNaN(+d) ? String(s) : d.toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); };
const pickTitle = (o: any) => o.name ?? o.title ?? o.description ?? o.class_name ?? o.course_name ?? (o.type ? "Lezione " + o.type : "Senza titolo");
const pickCenter = (o: any) => o.tenant_name ?? o.club_name ?? o.center_name ?? (o.tenant && (o.tenant.tenant_name || o.tenant.name)) ?? "";
const isoNoZ = (d: Date) => d.toISOString().replace(/\.\d{3}Z$/, "");

function LessonCard({ o }: { o: any }) {
  const center = pickCenter(o), date = pickDate(o), price = pickPrice(o), sport = o.sport_id || o.sport || "";
  return (
    <div className="rounded-lg border border-slate-200 p-2.5">
      <div className="flex items-center justify-between gap-2"><b className="text-sm text-slate-800">{pickTitle(o)}</b>{price ? <Pill tone="green">{price}</Pill> : null}</div>
      {center ? <div className="text-xs text-slate-500">🏟️ {center}</div> : null}
      {date ? <div className="text-xs text-slate-500">🗓️ {date}</div> : null}
      {sport ? <div className="text-xs text-slate-400">{sport}</div> : null}
    </div>
  );
}

function Sec({ acct, title, loader }: { acct: string; title: string; loader: () => Promise<unknown> }) {
  const [data, setData] = useState<any[] | null>(null);
  useEffect(() => { let a = true; setData(null); loader().then((d) => a && setData(asList(d))).catch(() => a && setData([])); return () => { a = false; }; }, [acct]);
  return (
    <Card title={title}>
      {data == null ? <div className="text-sm text-slate-500">carico…</div> : data.length === 0 ? <div className="text-sm text-slate-500">Nessun risultato.</div> : (
        <div className="grid gap-2" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(240px,1fr))" }}>{data.map((o, i) => <LessonCard key={i} o={o} />)}</div>
      )}
    </Card>
  );
}

export default function Lessons() {
  const [acct, setAcct] = useState("moving");
  const [count, setCount] = useState<number | null>(null);
  const today = new Date(), plus30 = new Date(Date.now() + 30 * 864e5);
  useEffect(() => { ptapp.call<any>(acct, "app", "v1/classes/recommendations/count", { params: { coordinate: COORD } }).then((c) => setCount(c?.count ?? c?.total ?? c?.value ?? null)).catch(() => setCount(null)); }, [acct]);
  return (
    <div className="mx-auto max-w-5xl space-y-4 p-4">
      <div className="flex items-center gap-3"><h2 className="text-lg font-bold text-slate-900">Lezioni</h2><AccountSelect value={acct} onChange={setAcct} /></div>
      {count != null && <Card><div className="flex items-center justify-between"><span className="text-sm text-slate-700">Classi consigliate nella tua zona</span><Pill tone="green">{count}</Pill></div></Card>}
      <Sec key={acct + "l"} acct={acct} title="Lezioni" loader={() => ptapp.call(acct, "app", "v1/lessons", { params: { from_start_date: isoNoZ(today), to_start_date: isoNoZ(plus30), size: 20, skip_count: "true", sort: "start_date,created_at,ASC", status: "REGISTRATION_OPEN,REGISTRATION_CLOSED,IN_PROGRESS", user_id: "me" } })} />
      <Sec key={acct + "c"} acct={acct} title="Corsi" loader={() => ptapp.call(acct, "app", "v1/courses", { params: { coordinate: COORD } })} />
    </div>
  );
}
